import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {CareproviderUnitService} from '../../../../../../services/careprovider-unit.service';
import {WindowSizeService} from '../../../../../../services/window-size.service';

@Component({
  selector: 'app-cpru-small-widgets',
  templateUrl: './cpru-small-widgets.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-row gap-4 justify-start items-center',
  },
})
export class CpruSmallWidgetsComponent {
  private careproviderUnitService = inject(CareproviderUnitService);
  protected careproviderUnit = this.careproviderUnitService.careproviderUnit;
  protected address = this.careproviderUnitService.address;
  private windowSize = inject(WindowSizeService);
  private size = this.windowSize.windowSize;
  private readonly mobileTabsThreshold = 992;
  protected isMobile = computed<boolean>(() => this.size()[0] < this.mobileTabsThreshold);

  public openMap(): void {
    this.careproviderUnitService.openMap();
  }
}
